import { orderDdd, addOrderApi } from '@/api/order.js'
import { doPay, moviePayApi } from '@/api/pay'
import { getuser } from '@/api/user'
import { getPayInfo, setAddressId, setPayInfo } from '@/utils/Address.js'
import isWeChatWeb from '@/utils/checkWebUserAgent'
import weChatJsApiPay from '@/utils/weChatJsApiPay'
import { judgeUserAgent } from '@/utils/judgeUserAgent'
import router from '@/router'
import {
  getAddressInfo,
  getDefaultAddress
} from '@/api/address'


import { preview, previewOneKey } from '@/api/order'


//  orderInfo: {
//     pay_goods_type: cake 蛋糕 |  '' 不传为普通支付
//     goods_sn: 商品id
//     paymentType: 1 积分支付 | 2 余额支付 | 3 微信支付 | 20 混合支付
//     remark: 备注
//     distribution_date: 配送日期
//     distribution_time: 配送时间
//     distribution_type: 配送方式
//     cake_addr: 蛋糕地址
//     goods_type: 蛋糕类型
//   }

/**
 * @typedef {Object} orderOtions
 * @property {string} pay_goods_type - 商品类型（可选，默认为空）cake 蛋糕 |  '' 不传为普通支付
 * @property {string} goods_sn - 商品编号
 * @property {number} paymentType - 支付方式（1 积分支付 | 2 余额支付 | 3 微信支付 | 20 混合支付)
 * @property {string} remark - 备注（可选）
 * @property {string} distribution_date - 配送日期（可选）
 * @property {string} distribution_time - 配送时间（可选）
 * @property {string} distribution_type - 配送方式（可选）
 * @property {string} address_id - 配送地址（必选）
 * @property {string} goods_type - 蛋糕类型（可选）(4 蛋糕)
 */

/**
 * 支付处理（对象参数版）
 * @param {orderOtions} orderInfo - 支付配置参数
 * @returns {orderOtions} - 支付配置参数
 */

const paymentTypeHandle = ({ state, getters, dispatch }, orderInfo) => {
      const type = ['carts_id', 'goods_sn']
      let payType = '' // 支付类型
      let payInfo = '' // 支付信息

      // 蛋糕结算
      if (
        orderInfo.pay_goods_type &&
        orderInfo.pay_goods_type === 'cake'
      ) {
        payType = type[1]
        payInfo =
          getters.getPayInfo.payInfo[0].goods_size[0]

    }
  // 普通结算
  if (!orderInfo.pay_goods_type) {
      if (
        getters.getPayInfo['payType'] ===
        state.paymentType.cart
      ) {
        // 购物车结算
        payType = type[0]
        payInfo = `[${getters.getPayInfo['payInfo']}]`
      }
      // 立即购买结算
      if (
        getters.getPayInfo['payType'] ===
        state.paymentType.buyNow
      ) {
        payType = type[1]
        payInfo = getters.getPayInfo['payInfo'].toString()
      }
  }
    
  return {
    payType,
    payInfo
  }
}

/**
 *  @param {orderOtions} orderInfo - 支付配置参数
 *  @param {string} payType - 支付类型
 * 
*/

// 加入订单
const orderAdd = async ({
  orderInfo,
  payType,
  payInfo,
  address_id
}) => {
  const {
    distribution_date,
    distribution_time,
    distribution_type,
    cake_addr,
    goods_type
  } = orderInfo

  const result = await addOrderApi({
    [payType]: payInfo,
    address_id: address_id,
    remark: orderInfo.remark || undefined,
    payment_type: orderInfo.paymentType,
    distribution_date: distribution_date || undefined,
    distribution_time: distribution_time || undefined,
    distribution_type: distribution_type || undefined,
    cake_addr: cake_addr || undefined,
    goods_type: goods_type || undefined
  }).catch(err => console.log(err))
  return result.data.data
}

// 跳转到支付平台
/*
  order_type: 1 电影订单
  pay_id: 支付id
*/
function toPaymentPlatform ({ pay_id, order_type = '' }) {
     router.push({
       path: '/paymentPlatform',
       query: {
         pay_id: pay_id,
         order_type: order_type
       }
     })
}


/*
* @param {string} payType - 支付类型
* @param {string} addressId - 地址id
* @param {string} payInfo - 支付信息
* @returns {object} - 支付信息
**/
const fetchOrderPreview = async (
  payType,
  addressId,
  payInfo
) => {
  if (payType === 'cart') {
    return await preview({
      address_id: addressId,
      carts_id: `[${payInfo}]`
    })
  } else if (payType === 'buyNow') {
    return await previewOneKey({
      address_id: addressId,
      goods_sn: payInfo[0]
    })
  }
  return null
}

const storageGoodsInfo = {
  payInfo: [],
  payType: ''
}


const state = {
  addressId: '', // 支付地址
  payType: '', // 支付方式 cart 购物车结算 buyNow 立即购买结算
  payInfo: [],
  paymentType: {
    cart: 'cart',
    buyNow: 'buyNow'
  },
  welfareCard: { // 福利卡信息
    id: '',
    info: {}
  } 
}

const mutations = {
  SET_ADDRESSID: (state, addressId) => {
    if (addressId) {
      setAddressId(addressId)
      state.addressId = addressId
    }
  },
  GET_ADDRESSID: state => {
      return state.addressId 
  },
  // 设置支付信息
  /**
   * @typedef {Object} payInfo
   * @property {Array} payInfo - 支付信息
   * @property {String} payType - 支付类型 cart 购物车结算 buyNow 立即购买结算
  */
  SET_PAYINFO: (state, info) => {
    const { payInfo, payType } = info

    if (payInfo && payType) {
      state.payInfo = payInfo
      state.payType = payType

      storageGoodsInfo.payInfo = payInfo
      storageGoodsInfo.payType = payType

      setPayInfo(storageGoodsInfo)
    }
  },
    GET_PAYINFO (state) {
  }
}

const actions = {
  // 地址选择
  async setAddress({ state, commit }, addressId) {
      const result = await getDefaultAddress()
      if (Object.keys(result.data.data.addressInfo).length !== 0) {
        commit(
          'SET_ADDRESSID',
          result.data.data.addressInfo.address_id
        )
      } else {
        router.push({
          path: '/myaddress',
          hash:'select'
        })
      }

    // return result.data.data
    // this.addresInfo = result.data.data.addressInfo;
    // this.getGoods()
    // this.getPayInfoTypeHandle()
  },
  // 获取支付订单信息
  async getPayOrderInfo ({ state, getters, dispatch }, options = {}) {
    const {
      payInfo = state.payInfo,
      payType = state.payType,
      addressId = state.addressId
    } = options
    
    if (state.addressId === '') {
      await dispatch('setAddress')
      if (!state.addressId) {
        return Promise.reject(new Error('获取地址失败'))
      }
    }
    
    if (
      !state.addressId ||
      !state.payType ||
      !state.payInfo
    ) {
      // router.go(-1)
      return Promise.reject(new Error('获取支付信息失败'))
    }

    const result = await fetchOrderPreview(
      state.payType,
      state.addressId,
      state.payInfo
    )

    return result?.data?.data || null
  },
  // 重新支付
  async repay({ state, getters, dispatch }, info) {
    const { pay_type, pay_id } = info
    if (pay_type === 3) {
      if (
        judgeUserAgent('weChat') ||
        judgeUserAgent('miniProgram')
      ) {
        // 微信api支付
        return await dispatch(
          'wechatPayByjsApi',
          info.pay_id
        )
      } else {
        // 微信h5支付
        await dispatch('wechatPayByH5', info.pay_id)
      }
    } else {
      const payResult = await doPay({
        pay_id: pay_id
      })
      return payResult.data.data
    }
  },
  // 电影结算
  async moviePay({ state, getters, dispatch }, info) {
    const result = await moviePayApi({
      order_id: info.orderId,
      payment_type: info.paymentType
    })
    return result.data.data
  },

  async movieOrderPay({ state, getters, dispatch }, info) {
    if (info.paymentType === 3) {
      toPaymentPlatform({
        pay_id: info.pay_id,
        order_type: 'movie'
      })
      return {
        status: false,
        message: ''
      }
      // if (judgeUserAgent('weChat') || judgeUserAgent('miniProgram')) {
      //   // 微信api支付
      //   return await dispatch('wechatPayByjsApi', info.pay_id)
      // } else {
      //   // 微信h5支付
      //   await dispatch('wechatPayByH5', info.pay_id)
      // }
    } else {
      // 积分/余额支付
      return await dispatch('moviePay', info)
    }
  },

  /*
    支付结算
    @param {Object} orderInfo
    @param {String} orderInfo.goods_sn 商品id
    @param {String} orderInfo.pay_goods_type 支付商品类型 { cake 蛋糕 | '' 不传为普通支付}
    @param {Number} orderInfo.paymentType 支付类型 { 1 积分支付 | 2 余额支付 | 3 微信支付 | 20 混合支付 }
    @param {String} orderInfo.remark 备注
    @param {String} orderInfo.distribution_date 配送日期
    @param {String} orderInfo.distribution_time 配送时间
    @param {String} orderInfo.distribution_type 配送方式
    @param {String} orderInfo.goods_type 蛋糕类型
    @param {String} orderInfo.address_id 蛋糕地址
  */

  async payOrder({ state, getters, dispatch }, orderInfo) {
    const { payType, payInfo } = paymentTypeHandle(
      { state, getters, dispatch },
      orderInfo
    )

    // 初始化支付结果
    let payResult = {
      status: true,
      orderSn: '',
      message: '',
      payCancel: false
    }

    const addOrderResult = await orderAdd({
      orderInfo,
      payType,
      payInfo,
      address_id: getters.getAdddreId
    })
    if (!addOrderResult.status) {
      payResult.status = false
      payResult.message = addOrderResult.message

      return Promise.resolve(payResult)
    }
    // 判断是否还有未支付
    if (
      addOrderResult.orderInfo.payment_type_status !== false
    ) {
      payResult.orderSn = addOrderResult.orderInfo.order_sn
      payResult.message = '支付成功'
      return Promise.resolve(payResult)
    }

    const payId =
      addOrderResult.orderInfo.payment_type_detail.pay_id

    toPaymentPlatform({
      pay_id: payId
    })

    return {
      status: false,
      message: ''
    }

    // const paymentStatus = add
    // for (let i = 0; i < addOrderResult.orderInfo.payment.length; i++) {
    //   const item = addOrderResult.orderInfo.payment[i]
    //   if (Number(item.payType) === 3 && !item.status) {
    //     if (
    //       judgeUserAgent('weChat') ||
    //       judgeUserAgent('miniProgram')
    //     ) {
    //       // 微信api支付
    //       payResult = await dispatch(
    //         'wechatPayByjsApi',
    //         {
    //           pay_id: item.pay_id,
    //           order_sn: addOrderResult.orderInfo.order_sn
    //         }
    //       )
    //     } else {
    //       // 微信h5支付
    //       payResult = await dispatch('wechatPayByH5', item.pay_id)
    //     }
    //   } else {
    //     payResult.status = item.status
    //     payResult.message = payResult.status ? '支付成功' : '支付失败'
    //   }
    // }

    // payResult.orderSn = addOrderResult.orderInfo.order_sn

    // return Promise.resolve(payResult)
  },
  // 微信支付 h5
  async wechatPayByH5({ state }, pay_id) {
    const result = await doPay({
      pay_id: pay_id
    }).catch(err => console.log(err))
    const { status, payment } = result.data.data
    if (status && payment.pay_data.trade_type === 'MWEB') {
      document.location.href = payment.pay_data.mweb_url
    }
  },
  // 微信支付 微信浏览器
  async wechatPayByjsApi({ state }, paload) {
    // 获取openId
    const { order_sn, pay_id } = paload
    let openId = ''
    const openIdResult = await getuser()
    const {
      status: openIdStatus,
      isBindWechat
    } = openIdResult.data.data
    if (openIdStatus && isBindWechat) {
      openId = openIdResult.data.data.openId
    }
    // 调起支付
    const payResult = await doPay({
      pay_id: pay_id,
      openid: openId
    })

    const {
      status: payStatus,
      payment
    } = payResult.data.data

    if (payStatus) {
      // 唤起微信支付
      const wechatPayResult = await weChatJsApiPay({
        ...payment.pay_data,
        order_sn: order_sn
      }).catch(err => {
        console.log(err)
      })
      return wechatPayResult
    } else {
      return {
        status: false
      }
    }
  }
}

const getters = {
  welfareCard: state => state.welfareCard,

  getAdddreId: state => {
    return state.addressId
  },
  getPayInfo: state => {
    if (state.payInfo && state.payType) {
      return {
        payInfo: state.payInfo,
        payType: state.payType
      }
    } else {
      return {
        payInfo: [],
        payType: ''
      }
    }
  },

  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
